import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';
import { palette } from '../../styles/colors';

export interface StyledLinkSimpleProps {
  underlined?: boolean;
  hasIcon?: boolean;
  iconPosition?: 'left' | 'right';
  textColor?: string;
  justify?: 'stretch' | 'center' | 'left' | 'right';
  size?: string;
  sizeLg?: string;
  sizeSubLg?: string;
  sizeMd?: string;
  sizeSm?: string;
  sizeXs?: string;
}

export const StyledLinkSimple = styled.a<StyledLinkSimpleProps>`
    text-decoration: none;
    font-size: ${({ size }) => size ? size : '1rem'};
    line-height: ${({ hasIcon }) => hasIcon ? '24px' : '19px'};
    padding: 5px 0.5em 3px;
    color: ${({ textColor }) => textColor ?? palette.snowFlower};
    ${({ underlined }) => underlined ? 'border-bottom: solid 2px ' + palette.text : 'border-bottom: solid 2px transparent'};
    font-weight: 400;
    align-self: center;
    justify-self: ${({ justify }) => justify || 'stretch'};
    ${({ hasIcon, iconPosition }) => hasIcon && css`
        display: grid;
        column-gap: 6px;
        grid-template-columns: ${iconPosition === 'left' ? '24px 1fr' : '1fr 24px'};

    `}

    span {
        align-self: center;
        grid-row: 1 / 2;
    }

  ${({ sizeLg }) => !sizeLg ? '' : `
    @media all and (max-width: ${layout.lg}) {
        font-size: ${sizeLg}};
        line-height: ${sizeLg}};
    }`}
  ${({ sizeSubLg }) => !sizeSubLg ? '' : `
    @media all and (max-width: ${layout.subLg}) {
        font-size: ${sizeSubLg}};
        line-height: ${sizeSubLg}};
    }`}
  ${({ sizeMd }) => !sizeMd ? '' : `
    @media all and (max-width: ${layout.md}) {
        font-size: ${sizeMd};
        line-height: ${sizeMd};
    }`}
  ${({ sizeSm }) => !sizeSm ? '' : `
    @media all and (max-width: ${layout.sm}) {
        font-size: ${sizeSm};
        line-height: ${sizeSm};
    }`}
  ${({ sizeXs }) => !sizeXs ? '' : `
    @media all and (max-width: ${layout.xs}) {
        font-size: ${sizeXs};
        line-height: ${sizeXs};
    }`}
`

interface StyledLinkIconSpanProps {
  color: 'main' | 'text';
  iconPosition?: 'left' | 'right';
}

export const StyledLinkIconSpan = styled.span<StyledLinkIconSpanProps>`
    align-self: center;
    line-height: 0.875em;
    fill: ${({ color }) => color === 'main' ? palette.snowFlower : palette.text};
    ${({ iconPosition }) => iconPosition === 'left' ? 'grid-column: 1 / 2' : 'grid-column: 2 / 3'}
`
